export default __webpack_public_path__ + "static/media/stock.a11c4058.jpg";